import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AdminDatevIncometaxExportConfigService } from './api/admin-datev-incometax-export-config.service';
import { AdminDatevIncometaxExportConfigRequestService } from './api/admin-datev-incometax-export-config-request.service';
import { AdminDatevIncometaxExportJobService } from './api/admin-datev-incometax-export-job.service';
import { AdminDatevIncometaxMaintenanceService } from './api/admin-datev-incometax-maintenance.service';
import { AdminDatevIncometaxRequestAuditService } from './api/admin-datev-incometax-request-audit.service';
import { DatevIncometaxExportConfigService } from './api/datev-incometax-export-config.service';
import { DatevIncometaxExportJobService } from './api/datev-incometax-export-job.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
